import { createAsyncTypes } from 'utils/ActionCreator'

export const DATA_REQUEST_ASYNC = createAsyncTypes(
  'DATA_REQUEST_ASYNC',
  'IronScales/Dashboard/Home/EmailOverview'
)

export const INSPECTED_COUNT_REQUEST_ASYNC = createAsyncTypes(
  'INSPECTED_COUNT_REQUEST_ASYNC',
  'IronScales/Dashboard/Home/EmailOverview'
)

export const ERROR_MESSAGE = 'The requested data cannot be displayed. Please try again later.'
export const NO_DATA_MESSAGE =
  'There are no emails to display within the chosen time frame at this moment.'

export const LOG_TYPES = [
  'Suspicious email detected',
  'Suspicious email reported',
  'Email ignored (allow list)',
  'Classified as Phishing',
  'Classified as Spam',
  'Classified as Safe',
  'Reclassified as Phishing',
  'Reclassified as Spam',
  'Reclassified as Safe',
  'Revert to Phishing',
  'Revert to Spam',
  'Revert to Safe',
]

export const SPAM_EMAIL_DETECTED = 'Spam email detected'

export const INVESTIGATION_FILTERS_BY_VALUE = {
  DETECTED: {
    email_widget_type: ['Presumed phishing', 'Presumed spam', 'Impersonation banner'],
    log_type: LOG_TYPES,
  },
  PHISHING: {
    email_widget_type: ['Presumed phishing'],
    classification: ['Phishing', 'Unclassified'],
    log_type: LOG_TYPES,
  },
  IMPERSONATION_BANNERS: {
    email_widget_type: ['Impersonation banner'],
    has_incident: false,
    log_type: LOG_TYPES,
  },
}
